import { ICellRendererAngularComp } from 'ag-grid-angular';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { CombinationManagerService } from 'src/services/forecast-services/combination-manager.service';

@Component({
  selector: 'combination-edit-cell-renderer',
  template: `<a class="product-title-link" [title]="params.value" (click)="btnEditClickHandler()">{{params.value}}</a>`,
})
export class CombinationEditRenderer implements ICellRendererAngularComp, OnDestroy {
  params: any;

  constructor(private combinationManagerService: CombinationManagerService) {
  }

  agInit(params: any): void {
    this.params = params;
  }

  btnEditClickHandler() {
    this.combinationManagerService.setCombinationGridActionCellSubject({ combinationData: this.params.data });
  }

  refresh(params?: any): boolean {
    return true;
  }

  ngOnDestroy() {
    // no need to remove the button click handler
    // https://stackoverflow.com/questions/49083993/does-angular-automatically-remove-template-event-listeners
  }
}
